import { CategoryWiseTokenConsumptionModel } from "./category-wise-token-consumption.model";

export class SummaryReportModel {
    date: string;
    categoryWiseConsumption: CategoryWiseTokenConsumptionModel[];
    grandTotal: number;

    constructor(date: string, categoryWiseConsumption: CategoryWiseTokenConsumptionModel[], grandTotal: number) {
        this.date = date;
        this.categoryWiseConsumption = categoryWiseConsumption;
        this.grandTotal = grandTotal;
    }
}